export interface GroupedData {
  [key: string]: any;
  data: any[];
}

export const groupByKey = (
  originalObject: Record<string, any>[],
  groupByProperty: string,
  absoluteGroup?: boolean
): GroupedData[] => {
  const uniqueVals: Set<any> = new Set();
  const finalArray: GroupedData[] = [];

  originalObject &&
    originalObject.forEach((item) => {
      uniqueVals.add(item[groupByProperty]);
    });

  uniqueVals.forEach((property) => {
    const dataObj: any[] = [];

    const expectedObj: GroupedData | any = absoluteGroup
      ? {
          [property]: {
            data: dataObj,
          },
        }
      : {
          [groupByProperty]: property,
          data: dataObj,
        };

    originalObject.forEach((item) => {
      if (item[groupByProperty] === property) {
        dataObj.push(item);
      }
    });

    finalArray.push(expectedObj);
  });

  return finalArray;
};

export const arrayCompare = (a: unknown[], b: unknown[]): boolean => {
  if (a.length !== b.length) return false;
  const elements: Set<unknown> = new Set([...a, ...b]);

  for (const x of Array.from(elements)) {
    const count1: number = a.filter((e) => e === x).length;
    const count2: number = b.filter((e) => e === x).length;
    if (count1 !== count2) return false;
  }
  return true;
};

type Obj = Record<string, any>;

export const differenceInObj = <T extends Obj>(
  firstObj: T,
  secondObj: T | any,
  ignoreKeys: Array<keyof T> = []
): Partial<T> => {
  const differenceObj: Partial<T> = {};
  for (const key in firstObj) {
    if (
      Object.prototype.hasOwnProperty.call(firstObj, key) &&
      !ignoreKeys.includes(key)
    ) {
      if (firstObj[key] !== secondObj[key]) {
        differenceObj[key] = firstObj[key];
      }
    }
  }
  return differenceObj;
};

export const groupByLength = (data: any[], n: number): any[][] => {
  return Array.from({ length: Math.ceil(data.length / n) }, (_, i) =>
    data.slice(i * n, i * n + n)
  );
};
